export default __webpack_public_path__ + "cdd2fe1536f8d9c88c4b544633e90a0f.svg";